import { render, staticRenderFns } from "./continueStop.vue?vue&type=template&id=680a06e9&scoped=true&"
import script from "./continueStop.vue?vue&type=script&lang=js&"
export * from "./continueStop.vue?vue&type=script&lang=js&"
import style0 from "./continueStop.vue?vue&type=style&index=0&id=680a06e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a06e9",
  null
  
)

export default component.exports